/**
 * Swiper component
 */
 import Swiper, { Navigation } from 'swiper';
 import 'swiper/css';
Swiper.use([Navigation]);

const swiper = new Swiper('.product-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,

    breakpoints: {
      '1620': {
        slidesPerView: 3,
        spaceBetween: 30,},
      '1280': {
          slidesPerView: 2,
          spaceBetween: 40,},
      '1024': {
        slidesPerView: 2,
        spaceBetween: 30,},
      '810': {
        slidesPerView: 2,
        spaceBetween: 30,},
      '640': {
        slidesPerView: 1,
        spaceBetween: 30, 
      },
      '300': {
        slidesPerView: 1,
        spaceBetween: 30, 
      },
    },
  
    // Navigation arrows
    navigation: {
      nextEl: ".product-swiper-next",
      prevEl: ".product-swiper-prev",
    },
  });
  